import _ from 'lodash'

export const __ = _
